/**
 * Paleta e tokens de UI compartilhados.
 *
 * Centralizamos cores e medidas aqui para manter consistência visual entre
 * cenas e facilitar futuras mudanças (modo daltônico, dark/light, etc. — ver
 * CLAUDE.md §8 acessibilidade).
 *
 * Cores usam números (0xRRGGBB) para Graphics e strings (#RRGGBB) para Text.
 */

export const Palette = {
  background: 0x0b0b1a,
  backgroundCss: '#0b0b1a',

  primary: 0x7c3aed, // roxo geek
  primaryCss: '#7c3aed',

  accent: 0x06b6d4, // ciano neon
  accentCss: '#06b6d4',

  success: 0x22c55e, // verde-neon
  successCss: '#22c55e',

  danger: 0xef4444, // vermelho — uso pontual, nunca punitivo (ver §7)
  dangerCss: '#ef4444',

  warning: 0xfacc15, // amarelo
  warningCss: '#facc15',

  textPrimary: 0xf0f0ff,
  textPrimaryCss: '#f0f0ff',

  textMuted: 0x9b9bff,
  textMutedCss: '#9b9bff',

  textDim: 0x6a6a99,
  textDimCss: '#6a6a99',
} as const;

export const Layout = {
  /** Tamanho mínimo de toque em pixels — alvo confortável em mobile (CLAUDE.md §8). */
  minTouchTarget: 48,
  /** Raio padrão para retângulos arredondados. */
  cornerRadius: 16,
} as const;

export const Typography = {
  fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
} as const;
